// import PenerimaanIndex from "@/components/claim/penerimaan/penerimaanIndex.vue";
// import PenerimaanAdd from "@/components/claim/penerimaan/penerimaanAdd.vue";
import EmailNotificationIndex from "@/components/claim/emailnotification/emailNotificationIndex.vue";
// import PenerimaanDetail from "@/components/claim/penerimaan/penerimaanDetail.vue";


let routesEmailNotification = [
  {
    path: '', // child default
    name: "EmailNotificationIndex",
    component: EmailNotificationIndex
  },
//   {
//     path: 'add', // child default
//     name: "PenerimaanAdd",
//     component: PenerimaanAdd
//   },
//   {
//     path: 'edit/:id', // child default
//     name: "PenerimaanEdit",
//     component: PenerimaanEdit
//   },
//   {
//     path: 'detail/:id', // child default
//     name: "PenerimaanDetail",
//     component: PenerimaanDetail
//   },
  
];

export default routesEmailNotification;